module.exports = __webpack_public_path__ + "img/icon_unselected_xiaoxiongmao.ebfa8ddf.png";